module.exports = __webpack_public_path__ + "static/media/21ECLAC40.be035f8a.jpg";